import { render, staticRenderFns } from "./InputTime.vue?vue&type=template&id=20af3f00&scoped=true&"
import script from "./InputTime.vue?vue&type=script&lang=js&"
export * from "./InputTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af3f00",
  null
  
)

export default component.exports